module.exports = require('./helpers/bundle-url').getBundleURL('4ko55') + "icons.c14567a0.svg";